export const config = {
    scheduleSearchTimeout: 800,
    scheduleSearchIdAttr: "schedule-search-id",
    scheduleJobAttr: "data-job",
    scheduleSlot: ".schedule-slot",
    scheduleSlotSearchActiveClass: "schedule-slot--search-active",
    scheduleCardSearchActiveClass: "schedule-card--search-active",
    scheduleContentSearchActiveClass: "schedule-content--search-active",
    scheduleNavSearchActiveClass: "schedule-nav--search-active",
    scheduleNavBadge: ".schedule-nav__search-badge",
};
